// Help: customers text the store. Each message goes into Shopify Inbox through the store's chat
// (<shopify-chat>), where the team replies; quick answers cover the common questions instantly.
// If the chat can't open, the message goes by email through Shopify's contact form instead.
export const MAX_MESSAGE=500; // Shopify's chat refuses longer starter messages
export function cleanMessage(text){const t=typeof text==='string'?text.trim():'';return t&&t.length<=MAX_MESSAGE?t:null;}
// Only links inside the store (like /pages/wallpaper-library) become buttons under an answer.
export function storeLink(href){const h=typeof href==='string'?href.trim():'';return /^\/(?!\/)[A-Za-z0-9\-._~/?=&%#]*$/.test(h)?h:'';}
export function storeChat(doc){const el=doc.querySelector('shopify-chat');return el&&typeof el.sendStarterMessage==='function'?el:null;}
export function hadConversation(storage){try{return storage?.getItem('shopify-chat-populated')==='true';}catch{return false;}}
// The chat's own round button would sit on top of this page's text box, so it is hidden on this page only.
export const HIDE_LAUNCHER='.activator-nudge,.activator,[class*="floating-input"]{display:none!important}';
export function hideLauncher(chat,win=globalThis){
  const root=chat?.shadowRoot;if(!root)return false;
  try{const sheet=new win.CSSStyleSheet();sheet.replaceSync(HIDE_LAUNCHER);root.adoptedStyleSheets=[...root.adoptedStyleSheets,sheet];}
  catch{const style=win.document.createElement('style');style.textContent=HIDE_LAUNCHER;root.append(style);}
  return true;
}

export function start(root){
  const doc=root.ownerDocument,win=doc.defaultView,reduce=win.matchMedia?.('(prefers-reduced-motion: reduce)').matches===true;
  const $=s=>root.querySelector(s),thread=$('[data-thread]'),form=$('[data-composer]'),text=$('[data-text]'),send=$('[data-send]'),note=$('[data-note]'),reopen=$('[data-reopen]'),fallback=$('[data-fallback]');
  if(!thread||!form||!text||!send)return;
  const bubble=(kind,content)=>{const el=doc.createElement('div');el.className='tkh-msg tkh-'+kind;el.textContent=content;thread.append(el);return el;};
  // The text box sticks to the bottom of the screen, so scroll the whole page section to its end: the newest message lands just above the box.
  const settle=()=>win.requestAnimationFrame(()=>(root.querySelector('.tkh-wrap')||root).scrollIntoView?.({block:'end',behavior:reduce?'auto':'smooth'}));
  const say=message=>{if(!note)return;note.textContent=message;note.hidden=!message;};

  const ready=()=>{const chat=storeChat(doc);if(!chat)return;hideLauncher(chat,win);if(reopen&&hadConversation(win.sessionStorage))reopen.hidden=false;};
  ready();win.customElements?.whenDefined?.('shopify-chat').then(ready,()=>{});
  reopen?.addEventListener('click',()=>storeChat(doc)?.show());

  // Quick answers: the question goes out, a short "typing", then the answer (and a button if it has a link).
  let nudged=false;
  root.querySelectorAll('.tkh-chip').forEach(chip=>chip.addEventListener('click',()=>{
    const question=chip.dataset.question||chip.textContent.trim(),answer=(chip.dataset.answer||'').trim();
    if(!answer){text.value=question;sync();text.focus();return;}
    bubble('out',question);
    const typing=doc.createElement('div');typing.className='tkh-msg tkh-in tkh-typing';typing.setAttribute('aria-label','Typing');typing.append(doc.createElement('i'),doc.createElement('i'),doc.createElement('i'));thread.append(typing);settle();
    win.setTimeout(()=>{
      typing.remove();const reply=bubble('in',answer),href=storeLink(chip.dataset.link);
      if(href){const a=doc.createElement('a');a.className='tkh-link';a.href=href;a.textContent=(chip.dataset.linkLabel||'Open')+' →';reply.append(a);}
      if(!nudged){nudged=true;bubble('in','Still need us? Text below and a real person will reply.');}
      settle();
    },reduce?0:650);
  }));

  // Texting: Enter sends (Shift+Enter for a new line); the box grows with the message.
  const sync=()=>{send.disabled=!text.value.trim();text.style.height='auto';text.style.height=Math.min(text.scrollHeight,150)+'px';};
  text.addEventListener('input',sync);
  text.addEventListener('keydown',e=>{if(e.key==='Enter'&&!e.shiftKey&&!e.isComposing){e.preventDefault();form.requestSubmit?.()??form.dispatchEvent(new win.Event('submit',{cancelable:true}));}});
  const byEmail=(message,meta)=>{
    meta.textContent='Not sent yet';if(!fallback)return say('The chat could not open. Please try again in a moment.');
    const body=fallback.querySelector('[data-fallback-body]');if(body)body.value=message;
    fallback.hidden=false;fallback.querySelector('input[type=email]')?.focus();settle();
  };
  let sent=false;
  form.addEventListener('submit',e=>{
    e.preventDefault();const message=cleanMessage(text.value);
    if(!message){if(text.value.trim().length>MAX_MESSAGE)say(`That's a long one. Keep it under ${MAX_MESSAGE} characters, or send it in two texts.`);return;}
    say('');bubble('out',message);const meta=doc.createElement('p');meta.className='tkh-meta';meta.textContent='Sending…';thread.append(meta);
    text.value='';sync();settle();
    // Must run inside the tap: Shopify's chat only accepts a first message from a real tap or key press.
    const chat=storeChat(doc);if(!chat)return byEmail(message,meta);
    let sending;try{sending=chat.sendStarterMessage(message,'typed');}catch(error){sending=Promise.reject(error);}
    Promise.resolve(sending).then(()=>{
      meta.textContent='Delivered';if(reopen)reopen.hidden=false;hideLauncher(chat,win);
      if(!sent){sent=true;bubble('in','Sent. We\'ll reply in the chat, and you can come back to it from this page anytime.');}
    },()=>byEmail(message,meta));
  });

  // Back from the email form (Shopify reloads the page): show how it went.
  if(fallback&&(/[?&]contact_posted=true/.test(win.location.search)||win.location.hash==='#contact_form')){fallback.hidden=false;settle();}
}

if(typeof document!=='undefined')document.querySelectorAll('[data-tek-help]').forEach(start);
